import React from 'react';
import styled from 'styled-components';
import PosterAndSlidesCard from './PosterAndSlidesCard';
import IntroductionVideoCard from './IntroductionVideoCard';
import AudioDescriptionCard from './AudioDescriptionCard';
import { useVMState } from '../../containers/main';
import AudioRecordingView from './AudioRecordingView';

const Wrapper = styled.div`
    flex-shrink: 0;
    overflow: scroll;
    padding: 16px;
    margin: -16px;
    width: calc(${props => (props.iswindows ? '476px' : '459px')} + 32px);
`;

const CardsView = ({ localStream }) => {
    const stateCtx = useVMState();
    const { isRecordingAudio } = stateCtx;
    const isWindows = window.navigator.appVersion.indexOf('Win') !== -1;

    return (
        <Wrapper iswindows={isWindows ? 1 : 0}>
            {!isRecordingAudio && (
                <>
                    <PosterAndSlidesCard />
                    <IntroductionVideoCard localStream={localStream} />
                    <AudioDescriptionCard />
                </>
            )}
            {isRecordingAudio && <AudioRecordingView />}
        </Wrapper>
    );
};

export default CardsView;
